import { useEffect } from 'react'
import $ from 'jquery'

import jady from './chef.png'

import Menu from './Menu.js'
import facebook from './facebook.png'
import instagram from './instagram.png'
import twitter from './twitter.png'


const Navbar = () => {
   useEffect(()=>{
    $(document).ready(function(){
        $("#open").click(function(){
            $("ul").animate({
                left:'-25px'})
            $("ul").toggleClass("navbar")    
           

        })
    })
      
    $(document).ready(function(){
        $("#close").click(function(){
            $("ul").animate({
                left:'-500px'})
        })
    })

   
    $(document).ready(function(){
        $("#biriadd").click(function(){
            $("#biryani").show()
            $("#biridel").show()
           
        })
    })    

    $(document).ready(function(){
        $("#biridel").click(function(){
            $("#biryani").hide()
            $("#biridel").hide()
           
            
            
        })
    })
    $(document).ready(function(){
        $("#cartanimate").click(function(){
            $("ul").animate({left:'-500px'})
            $("#cartmove").toggleClass("move")
            $("#opennav").toggleClass("openmove")
            $("#menunav").toggleClass("menuopen")
        })
    })

    $(document).ready(function(){
        $("#contactanimate").click(function(){
            $("ul").animate({left:"-500px"})
            $("#cartmove").toggleClass("move")
            $("#opennav").toggleClass("openmove")
            $("#menunav").toggleClass("menuopen")
            $("#contact1").toggleClass("contactmove")
        })
    })
    
         
    
   })
    
    return ( 
     
      <>
      

<script src="https://cdnjs.cloudflare.com/ajax/libs/materialize/1.0.0/js/materialize.min.js"></script>
          <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/materialize/1.0.0/css/materialize.min.css"></link>
          <link href="https://fonts.googleapis.com/icon?family=Material+Icons" rel="stylesheet"></link>
        
     
      <body>
           
        <div >
       
        
            <nav style={{backgroundColor:"orange",height:"200px",backgroundColor:"transparent"}}>
                <div className="nav-wrapper">
                    
                    <h6 className="brand-logo center" style={{fontFamily:"Monaco,Monospace",position:"relative",bottom:"85px"}}>Jady's Kitchen</h6>
                    <img className="food hide-on-small-only"src={jady} alt={jady} style={{width:"10%",position:"relative",bottom:"-50px",left:"-500px"}}></img>
                    
                    <ul id="nav-mobile" className="right hide-on-med-and-down">
                        <li><a href="menu" style={{position:"relative",left:"-100px",bottom:"-15px",fontFamily:"Monaco,Monospace"}}>Menu</a></li>
                        <li><a href="#cart" style={{position:"relative",left:"-70px",bottom:"-15px",fontFamily:"Monaco,monospace"}}>Cart</a></li>
                        <li><a href="#cart" style={{position:"relative",left:"-40px",bottom:"-15px",fontFamily:"Monaco,monospace"}}>Contact</a></li>
                    </ul>
                    <h5 className="right hide-on-small-only" style={{position:"relative",bottom:"-100px",right:"-150px" ,color:"white",fontStyle:"Monaco,monospace"}}>Try saying <span style={{fontWeight:"bold",color:"orange",border:"1px solid black",backgroundColor:"black"}}>Hello Alan</span></h5>
                    <h6 className="right hide-on-large-only" style={{position:"relative",bottom:"-150px",right:"20px" ,color:"white",fontStyle:"Monaco,monospace"}}>Try saying <span style={{fontWeight:"bold",color:"orange",border:"1px solid black",backgroundColor:"black"}}>Hello Alan</span></h6>

                    <h6></h6>
                </div>
                <button id="open" className="hide-on-large-only"style={{cursor:"pointer",position:"relative",top:"-135px",backgroundColor:"transparent", border:"0px solid",right:"-10px"}}><i id="opennav" className="material-icons">menu</i></button>
                <h6 className=" hide-on-large-only" style={{fontFamily:"Monaco,Monospace",position:"relative",bottom:"200px",fontSize:"35px",right:"-80px"}}>Jady's Kitchen</h6>
            </nav> 
            
            <h6 className="hide-on-large-only men" style={{fontSize:"40px",color:"whitesmoke",position:"relative",right:"80px",bottom:"-50px",fontFamily:"Monaco,monospace"}}>Menu</h6>
          
            <div className="left hide-on-small-only" style={{border:"",width:"1519.5px",height:"150px",}}>
                <h3 id="menu"style={{position:"relative",bottom:"-20px",right:"-15px",fontFamily:"Monaco ,Monospace",fontWeight:"bold",color:"whitesmoke"}}>Menu</h3>
               
            </div>    
            <div>
                <Menu />
            </div>
            
            
            <ul className="z-depth-1"style={{border:"0.2px solid grey",width:"200px",height:"3500px",position:"relative",top:"-3040px",backgroundColor:"grey",left:"-250px"}}>
                <img className="jay hide-on-large-only" src={jady} style={{width:"60%",position:"relative",bottom:"-80px",right:"-50px"}} alt={jady}></img>
                <p><button id ="close" className="btn small z-depth-3" style={{position:"relative",right:"-145px",bottom:"120px",cursor:"pointer" ,backgroundColor:"grey",width:"34%",borderEndEndRadius:"25%"}}><i className="material-icons">close</i></button></p>
                
                <br />
                <li ><a className="hoverable" href="#menu" style={{color:"white",position:"relative",right:"-35px",bottom:"-20px",fontFamily:"Monaco,monospace",fontSize:"20px"}}><b id="menu1"style={{height:"20px"}}><button style={{backgroundColor:"transparent",color:"white"}}>Menu</button></b></a></li>
                <br />
                <hr style={{border:"0.2px solid darkgrey"}}/>
                
                <li><a id="cart"className="hoverable" href="#cart" style={{color:"white",position:"relative",right:"-35px",bottom:"-30px",fontFamily:"Monaco,monospace",fontSize:"20px"}}><button style={{backgroundColor:"transparent" ,color:"white"}}id="cartanimate">Cart</button></a></li>
                <br ></br>
                <hr style={{position:"relative",bottom:"-20px",border:"0.2px solid darkgrey"}} />
                <br />
                <li><a className="hoverable" href="#contact" style={{color:"white",position:"relative",right:"-35px",bottom:"-30px",fontFamily:"Monaco,monospace",fontSize:"20px"}}><button style={{backgroundColor:"transparent",color:"white"}} id ="contactanimate">Contact</button></a></li>
                <br />
                <hr style={{position:"relative",bottom:"-20px",border:"0.2px solid darkgrey"}}/>

            </ul>
            
           <div className="Footer" >
                 <h4  id="contact"style={{position:"relative",top:"-2600px",fontFamily:"Monaco,monospace",color:"white",right:"-20px"}}><b id="contact1">Contact Us</b></h4>
                 <p>
                     <a href="https://www.facebook.com/sayantan.ghosh.71066"><img className="hide-on-small-only" src={facebook} alt="Facebook" style={{width:"4%",position:"relative",top:"-2600px",right:"-20px"}}></img></a>
                     <a href="https://www.instagram.com/the_exotic_san/"><img className="hide-on-small-only" src={instagram} alt={instagram}style={{width:"3%",position:"relative",top:"-2595px",right:"-25px"}}></img></a>
                     <a href=""><img  className="hide-on-small-only"src={twitter} alt="twitter" style={{width:"2.2%",position:"relative",top:"-2601px",right:"-40px"}} ></img></a>
                 </p>
                 <p>
                 <a href="https://www.facebook.com/sayantan.ghosh.71066"><img className="hide-on-large-only" src={facebook} alt="Facebook" style={{width:"18%",position:"relative",top:"-2602px",right:"-20px"}}></img></a>
                     <a href="https://www.instagram.com/the_exotic_san/"><img className="hide-on-large-only" src={instagram} alt={instagram}style={{width:"15%",position:"relative",top:"-2595px",right:"-22px"}}></img></a>
                     <a href="https://twitter.com/Sayanta58279505"><img  className="hide-on-large-only"src={twitter} alt="twitter" style={{width:"10%",position:"relative",top:"-2602px",right:"-40px"}} ></img></a> 
                 </p>
           </div>
                 
            
        </div>
    
       
       </body>
       

        </>

        
        
     );
}
 
export default Navbar;